<template>
    <div class="qwewqdsad">
        <el-dialog :title="titleName" class="wwweditcss" width="60%" :visible.sync="dialogFormVisible">
            <div id="aprication">
                <div class="headerp-div">
                    <div class="header-div">
                        <div style="float: right">
                            <el-button size="mini" v-if="$hasPerm('business:reportStatisticalFormula:add')"
                                       @click="handleAdd()" style=";background-color:#16E3A1;color: white">保存<i
                                    class="el-icon-plus"></i></el-button>
                        </div>
                        <div style="float: left;vertical-align: center;margin: 5px;">
                            科目：
                        </div>
                        <div style="float: left;margin-right: 5px;">
                            <el-input
                                    class="queryInput"
                                    v-on:click.native="selectkm"
                                    readonly
                                    size="mini"
                                    placeholder="请输选择科目"
                                    v-model="kmCodeName"
                                    clearable>
                            </el-input>
                        </div>
                        <div style="float: left;vertical-align: center;margin: 5px;">
                            运算符号：
                        </div>
                        <div style="float: left;margin-right: 5px;">
                            <el-select size="mini" v-model="form.ysfh" class="queryInput" placeholder="请选择运算符号">
                                <el-option value="+" label="+"/>
                                <el-option value="-" label="-"/>
                            </el-select>
                        </div>

                        <div style="float: left;vertical-align: center;margin: 5px;" v-if="reportCode=='report_zcfzb'">
                            取数规则：
                        </div>
                        <div style="float: left;margin-right: 5px;" v-if="reportCode=='report_zcfzb'">
                            <el-select size="mini" v-model="form.qsgzCode" class="queryInput" placeholder="请选择取数规则">
                                <el-option value="1" label="余额"/>
                                <el-option value="2" label="借方余额"/>
                                <el-option value="3" label="贷方余额"/>
                            </el-select>
                        </div>

                    </div>
                </div>
                <el-table :data="tableData" border size="mini" height="300" style="width: 100%">
                    <el-table-column prop="kmmc" width="420" label="科目名称">
                        <template slot-scope="scope">
                            {{scope.row.kmdm}} {{scope.row.kmmc}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="ysfh" label="运算符号"></el-table-column>
                    <el-table-column prop="qsmcName" v-if="reportCode=='report_zcfzb'" label="取数规则"></el-table-column>
                    <el-table-column prop="qiMoShu" :label="qiMoShuName"></el-table-column>
                    <el-table-column prop="nianChuShu" :label="nianChuShuName"></el-table-column>
                    <el-table-column label="操作"
                                     v-if="$hasPerm('business:reportStatisticalFormula:edit,business:reportStatisticalFormula:remove')">
                        <template slot-scope="scope">
                            <el-button size="mini" slot="reference" @click="handleDelete(scope.$index, scope.row)"
                                       v-if="$hasPerm('business:reportStatisticalFormula:remove') && scope.row.id != null"
                                       type="text">
                                删除<i class="el-icon-delete"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <kemu v-if="editVisible" ref="kemu" @selectkmId="selectkmId"></kemu>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import Kemu from './kemu'

    export default {
        name: 'reportStatisticalFormulaList',
        components: {
            Kemu
        },
        data() {
            return {
                tableData: [],
                kmCodeName: '',
                titleName: '',
                reportCode: '',
                zqDate: null,
                qiMoShuName: '期末数',
                nianChuShuName: '年初数',
                editVisible: false,
                dialogFormVisible: false,
                form: {
                    tjxId: '',
                    kmId: '',
                    qsgzCode: '1',
                    qsmcName: '',
                    ysfh: '+'
                }
            }
        },
        methods: {
            int(itemId, reportCode, itemName, zqDate) {

                this.reportCode = reportCode;
                this.zqDate = zqDate;

                this.kmCodeName = '';
                this.titleName = '库表-设置（' + itemName + '）统计项公式'
                this.form.tjxId = itemId;
                this.form.kmId = '';
                this.form.qsgzCode = '1';
                this.form.qsmcName = '余额';
                this.form.ysfh = '+';

                if (this.reportCode != 'report_zcfzb') {
                    this.form.qsgzCode = '';
                    this.form.qsmcName = '';
                    this.qiMoShuName = '本期金额';
                    this.nianChuShuName = '本年累计';
                } else {
                    this.qiMoShuName = '期末数';
                    this.nianChuShuName = '年初数';
                }

                this.dialogFormVisible = true;
                this.handleCurrentChange();
            },
            handleCurrentChange() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/reportStatisticalFormula/list'),
                    method: 'get',
                    params: {
                        'reportCode': this.reportCode,
                        'zqDate': this.zqDate,
                        'tjxId': this.form.tjxId
                    }
                }).then(r => {
                    this.tableData = r.data.data;
                }).finally(r => {
                })
            },
            handleAdd() {

                if (!this.form.tjxId) {
                    this.$message({
                        type: 'warning',
                        message: '统计项ID不能为空！'
                    })
                    return false;
                }

                if (!this.form.kmId) {
                    this.$message({
                        type: 'warning',
                        message: '请选择添加科目！'
                    })
                    return false;
                }

                if (!this.form.ysfh) {
                    this.$message({
                        type: 'warning',
                        message: '请选择运算符号！'
                    })
                    return false;
                }

                if (this.form.qsgzCode == '1') {
                    this.form.qsmcName = '余额';
                } else if (this.form.qsgzCode == '2') {
                    this.form.qsmcName = '借方余额';
                } else if (this.form.qsgzCode == '3') {
                    this.form.qsmcName = '贷方余额';
                } else {
                    this.form.qsgzCode = '';
                    this.form.qsmcName = '';
                }

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl("/business/reportStatisticalFormula/save"),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        ...this.form
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.data.msg
                        })
                    }
                })
            },
            selectkm() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.kemu.int();
                })
            },
            selectkmId(node) {
                this.form.kmId = node.id;
                this.kmCodeName = node.sname;
            },
            handleDelete(index, row) {
                this.$confirm('确定删除吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let id = row.id;
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/reportStatisticalFormula/remove'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$notify({
                                title: '操作成功！',
                                type: 'success',
                                offset: 600
                            });
                            this.handleCurrentChange();
                        } else {
                            this.$message({ // 失败
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    })
                }).catch(() => {
                });
            }
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 100%;
        text-align: right;
        border: #EBEEF5 1px solid;
        padding: 10px;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 150px;
    }

    .wwweditcss >>> .el-dialog__body {
        padding: 10px 35px 25px 35px;
        height: 420px;
    }

    .qwewqdsad >>> .el-table tr:hover {
        text-decoration: none !important;
    }
</style>